var _style, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEnd = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "endPin",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 47.3",
    style: {
      enableBackground: "new 0 0 28 47.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.end-pin-st0{opacity:0.42; enable-background:new;}\r\n\t.end-pin-st1{fill:#FFFFFF;}\r\n\t.end-pin-st2{fill:#FF9E00;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "end-pin-st0",
    cx: 14.8,
    cy: 35.1,
    r: 12.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "end-pin-st1",
    cx: 14,
    cy: 34.7,
    r: 11.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "end-pin-st2",
    d: "M9.1,29.6c0,0.4-0.2,0.7-0.5,0.9v10.2c0,0.1-0.1,0.1-0.1,0.2H8.4H7.8c-0.1,0-0.2,0-0.2-0.1l-0.1-0.1V30.5 C7.2,30.3,7,30,7,29.6c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.3,0.8-0.3c0.4,0,0.6,0.1,0.8,0.3C9,29,9.1,29.3,9.1,29.6z M21,30.1v6.2 c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.1,0.1-0.3,0.2c-1.1,0.6-2.1,0.9-3,0.9c-0.3,0-0.6-0.1-1-0.2c-0.3-0.1-0.6-0.2-0.9-0.4 c-0.3-0.2-0.6-0.2-0.9-0.4c-0.4-0.1-0.8-0.2-1.1-0.2c-1.1,0-2.3,0.4-3.8,1.2c-0.1,0.1-0.2,0.1-0.2,0.1c-0.2,0-0.2-0.1-0.4-0.1 c-0.1-0.1-0.1-0.2-0.1-0.4v-6c0-0.1,0.1-0.3,0.2-0.4c0-0.2,0.3-0.3,0.6-0.4c1.2-0.7,2.4-1,3.4-1c0.6,0,1.1,0.1,1.6,0.2 c0.5,0.1,1.1,0.4,1.8,0.7c0.2,0.1,0.5,0.2,0.8,0.2s0.6-0.1,1-0.2c0.3-0.1,0.6-0.2,0.9-0.4c0.2-0.2,0.5-0.2,0.7-0.4 c0.2-0.1,0.4-0.2,0.5-0.2s0.2,0.1,0.3,0.2C21,29.8,21,29.9,21,30.1z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/end.fcdb4b12.svg";
export { ForwardRef as ReactComponent };